import React, {useEffect, useState, useContext} from "react"
import LineItemDetails from "./LineItemDetails"
import {LineItem} from "../../../dtos/orderResponse"
import {RefundInfo} from "../../../dtos/refundInfo"
import {Event, ItemKeyEvents} from "../../../dtos/eventResponse"
import TenantService from "../../../services/tenant/TenantService"
import {OrderCredits} from "../../../services/order/CreditDetails"
import {TenantsContext} from "../../../contexts/TenantsContext"
import MultiselectBar from "../../../componenets/multiSelectBar/MultiSelectBar"
import * as Order from "../../../dtos/orderResponse"
import {Grid} from "@mui/material"

interface LineItemsProps {
	customerId: string
	orderId: string
	order: Order.Order
	orderNumber: string
	orderIsLegacy: boolean
	lineItems: Array<LineItem>
	updateParent: () => {}
	orderRefInfo: RefundInfo
	culture: string
	itemsNumber: number
	tenantId: string
	isAnonymousCustomer: boolean
	events: Event[]
	cartId: string
	isFullyPaidWithMC: boolean
	paymentFullySuccessful: boolean
	orderCredits: OrderCredits | null
	orderCreationDate: Date
	orderIsReleasedToFulfillment: boolean
	isVCSAgent: boolean
	isVCSOrder: boolean
	defaultCountryCode: string
	itemsKeyEvents: ItemKeyEvents[]
	isPayOnBillingAccountOrder: boolean
	isCompanyCardOrder: boolean
}

export default function LineItems(props: LineItemsProps) {
	const [tenantForPurcs, setTenantForPurcs] = useState("")
	const [selectedItems, setSelectedItems] = useState<LineItem[]>([])
	const {tenants} = useContext(TenantsContext)
	useEffect(() => {
		const getTenantForPurcs = async () => {
			await new TenantService().getTenantDetails(props.tenantId, tenants).then((res) => {
				setTenantForPurcs(res.merchantId + "-prod")
			})
		}

		getTenantForPurcs()
	}, [props.tenantId, tenants])

	const onMainCheckboxClick = (isChecked: boolean) => {
		if (isChecked) {
			setSelectedItems(props.lineItems)
		} else {
			setSelectedItems([])
		}
	}
	const handleCheckboxChange = (lineItem: LineItem, checked: any) => {
		setSelectedItems((prevSelected) => {
			if (checked) {
				return [...prevSelected, lineItem]
			} else {
				return prevSelected.filter((item) => item.id !== lineItem.id)
			}
		})
	}
	const getItemKeyEvents = (itemId: string): Event[] => {
		const filteredKeyEvents = props.itemsKeyEvents.filter((items) => items.itemdId === itemId)
		if (filteredKeyEvents.length > 0) {
			const keyEvents = filteredKeyEvents[0].events
			return keyEvents.map((keyEvent) => keyEvent.event)
		}
		return []
	}

	useEffect(() => {
		if (selectedItems.length > 0) {
			const updatedSelectedItems = selectedItems.map(
				(selectedItem) =>
					props.lineItems.find((lineItem) => lineItem.id === selectedItem.id) || selectedItem
			)
			setSelectedItems(updatedSelectedItems)
		}
		// eslint-disable-next-line
	}, [props.lineItems])

	return (
		<div>
			<MultiselectBar
				orderPaymentsData={props.order?.orderData?.payments}
				onMainCheckboxClick={onMainCheckboxClick}
				removeLineItem={handleCheckboxChange}
				customerId={props.customerId}
				tenant={props.tenantId}
				selectedItems={selectedItems}
				setSelectedItems={setSelectedItems}
				reloadParent={props.updateParent}
				isVCSOrder={props.isVCSOrder}
				orderIsLegacy={props.orderIsLegacy}
				cartId={props.cartId}
				orderIsReleasedToFulfillment={props.orderIsReleasedToFulfillment}
				isVCSAgent={props.isVCSAgent}
				orderNumber={props.orderNumber}
				orderCredits={props.orderCredits}
				events={props.events}
				culture={props.culture}
				defaultCountryCode={props.defaultCountryCode}
				isPayOnBillingAccountOrder={props.isPayOnBillingAccountOrder}
				isCompanyCardOrder={props.isCompanyCardOrder}
				isFullyPaidWithMC={props.isFullyPaidWithMC}
				paymentFullySuccessful={props.paymentFullySuccessful}
				isAnonymousCustomer={props.isAnonymousCustomer}
			/>
			<Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={4}>
				{props.lineItems.map((lineItem) => (
					<Grid item key={lineItem.id}>
						<LineItemDetails
							isChecked={
								Array.isArray(selectedItems) &&
								selectedItems.some((item) => item.id === lineItem.id)
							}
							onCheckboxChange={handleCheckboxChange}
							customerId={props.customerId}
							orderId={props.orderId}
							order={props.order}
							lineItem={lineItem}
							orderNumber={props.orderNumber}
							updateParent={props.updateParent}
							orderRefInfo={props.orderRefInfo}
							orderIsLegacy={props.orderIsLegacy}
							culture={props.culture}
							itemsNumber={props.itemsNumber}
							tenantId={props.tenantId}
							isAnonymousCustomer={props.isAnonymousCustomer}
							events={props.events}
							cartId={props.cartId}
							purcsData={lineItem.purcsData}
							tenantForPurcs={tenantForPurcs}
							isFullyPaidWithMC={props.isFullyPaidWithMC}
							paymentFullySuccessful={props.paymentFullySuccessful}
							orderCredits={props.orderCredits}
							orderCreationDate={props.orderCreationDate}
							orderIsReleasedToFulfillment={props.orderIsReleasedToFulfillment}
							isVCSAgent={props.isVCSAgent}
							isVCSOrder={props.isVCSOrder}
							defaultCountryCode={props.defaultCountryCode}
							itemKeyEvents={getItemKeyEvents(lineItem.id)}
							isPayOnBillingAccountOrder={props.isPayOnBillingAccountOrder}
							isCompanyCardOrder={props.isCompanyCardOrder}
						/>
					</Grid>
				))}
			</Grid>
			<br />
		</div>
	)
}
